import styled from 'styled-components';
import React from 'react';

import Button from '../../other-components/Button';
import Modal from '../Modals/Modal';

const Header = styled.div`
    height: 40px;
    display: flex;
    font-weight: 500;
    padding-left: 15px;
    align-items: center;
    justify-content: space-between;
    color: ${({ theme }) => theme.titleText};
    border-bottom: 1px solid ${({ theme }) => theme.inputBorder};
`;

const ModalInner = styled.div`
    width: 300px;
    /* height: 400px; */
    border-radius: 5px;
    transform: translateY(-50%);
    box-shadow: 0 0 60px 0 rgba(43, 53, 86, 0.15);
    background: ${({ theme }) => theme.primary.bg};
`;

const ModalBody = styled.div`
    padding: 15px;
`;

const DragArea = styled.div`
    width: 100%;
    height: 100%;
`;

let handleDragging = e => {
    console.log(e);
};

const ColorPickerModal = ({ children, close, position }) => {
    return (
        <Modal>
            <DragArea>
                <ModalInner
                    style={{
                        ...position,
                        position: 'fixed',
                    }}
                >
                    <Header>
                        Color Picker
                        <Button
                            size="sm"
                            type="none"
                            onClick={close}
                            icon={['far', 'times']}
                        />
                    </Header>
                    <ModalBody>{children}</ModalBody>
                </ModalInner>
            </DragArea>
        </Modal>
    );
};

export default ColorPickerModal;
